// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ZuK9gSoeYEz_4w {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
}
.tZhnhXBAHhVbqR {
  display: flex;
  justify-content: center;
}
.OvSuJqKN5w5mIl {
  flex: 1 1 auto;
  min-height: calc(100vh - 40px);
  padding-bottom: 32px;
  background-color: var(--ds-surface, #ffffff);
}
.fekai0aBn6LKGj {
  display: flex;
  justify-content: center;
  padding-top: 32px;
}
@media only screen and (max-width: 600px) {
  .fekai0aBn6LKGj {
    display: block;
    padding-top: 0;
  }
}
@media only screen and (max-width: 860px) {
  .fekai0aBn6LKGj.x1JzLB38bDc0If {
    display: block;
    padding-top: 0;
  }
}
.ZT2_vbuAEDRgBm {
  width: 960px;
}
@media only screen and (max-width: 1242px) {
  .ZT2_vbuAEDRgBm {
    width: 640px;
  }
}
@media only screen and (max-width: 1007px) {
  .ZT2_vbuAEDRgBm {
    width: 100%;
  }
}
@media only screen and (max-width: 600px) {
  .ZT2_vbuAEDRgBm.EqvQzrSYWyM4xN {
    display: none;
  }
}
.ZT2_vbuAEDRgBm.x1JzLB38bDc0If {
  width: 960px;
}
@media only screen and (max-width: 1520px) {
  .ZT2_vbuAEDRgBm.x1JzLB38bDc0If {
    width: 640px;
  }
}
@media only screen and (max-width: 1267px) {
  .ZT2_vbuAEDRgBm.x1JzLB38bDc0If {
    width: 100%;
  }
}
.ejlp3myxE4QZhe {
  display: flex;
  align-items: center;
  justify-content: center;
}
.IgaAMasHnsm9Jn {
  padding: 0 15%;
  color: var(--ds-text, #172b4d);
  font-size: 14px;
  line-height: 24px;
}
@media only screen and (max-width: 1242px) {
  .IgaAMasHnsm9Jn {
    padding: 0 10%;
  }
}
.IgaAMasHnsm9Jn .FvVU_pT59kPiTI {
  width: 100%;
  margin: 16px auto;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"flexRowWrap": `ZuK9gSoeYEz_4w`,
	"flexAndCenter": `tZhnhXBAHhVbqR`,
	"directoryBody": `OvSuJqKN5w5mIl`,
	"navigationAndContent": `fekai0aBn6LKGj`,
	"workspaceNavigationExpanded": `x1JzLB38bDc0If`,
	"directoryContent": `ZT2_vbuAEDRgBm`,
	"navigationExpanded": `EqvQzrSYWyM4xN`,
	"directorySpinnerContainer": `ejlp3myxE4QZhe`,
	"listingWrapper": `IgaAMasHnsm9Jn`,
	"upgradePromptFullPupPage": `FvVU_pT59kPiTI`
};
export default ___CSS_LOADER_EXPORT___;
